// The sign-in steps in the order the API asks for them (the same as App admin and the Lender Hub): nobody yet ->
// password; `mfa` -> the code (only for someone with 2-step on); `change_password` -> their own password after a
// one-time one; `mfa_setup` -> set up 2-step (only when the rule is `required`). On the mock API the Test tools
// button sits in the corner here too.
import type { Session } from '@/api/schemas'
import { TestToolsButton } from '../test-tools/TestToolsButton'
import { CodeStep } from './CodeStep'
import { NewPasswordStep } from './NewPasswordStep'
import { PasswordStep } from './PasswordStep'
import { SetupStep } from './SetupStep'

function Step({ session }: { session: Session | null }) {
  if (!session) return <PasswordStep />
  if (session.stage === 'mfa') return <CodeStep user={session.user} />
  if (session.stage === 'change_password') return <NewPasswordStep />
  return <SetupStep />
}

export function SignInFlow({ session }: { session: Session | null }) {
  return (
    <>
      <Step session={session} />
      <TestToolsButton />
    </>
  )
}
